import comp from "./SuperAdmin";
export default comp;
